import { styled } from "@mui/material/styles";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
} from "@mui/material";
import { colors } from "../../../theme/theme";

export const StyledDialog = styled(Dialog)({
  "& .MuiDialog-paper": {
    borderRadius: "20px",
    color: colors.primary,
    boxShadow: "0px 0px 50px 0px #0000000D",
    maxWidth: "600px",
    padding: 8,
  },
});

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  fontFamily: "'Gotham', sans-serif",
  fontSize: "24px",
  color: colors.primary,
  textAlign: "center",
  [theme.breakpoints.down("md")]: {
    fontSize: "20px",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "18px",
  },
}));

export const StyledDialogContent = styled(DialogContent)({});

export const BodyText = styled(Typography)(({ theme }) => ({
  fontSize: theme.spacing(2),
  textAlign: "justify",
  marginBottom: theme.spacing(2),
  fontFamily: "'Quicksand', sans-serif",
  [theme.breakpoints.down("md")]: {
    fontSize: "14px",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "12px",
  },
}));

export const SubtitleText = styled(Typography)(({ theme }) => ({
  fontWeight: "bold",
  marginTop: 16,
  fontFamily: "'Quicksand', sans-serif",
  [theme.breakpoints.down("md")]: {
    fontSize: "14px",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "12px",
  },
}));

export const StyledList = styled("ul")(({ theme }) => ({
  paddingLeft: "20px",
  marginBottom: theme.spacing(2),
  fontFamily: "'Quicksand', sans-serif",
  [theme.breakpoints.down("md")]: {
    fontSize: "14px",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "12px",
  },
}));

export const StyledDialogActions = styled(DialogActions)({
  paddingTop: 0,
  paddingBottom: 0,
  borderRadius: 4,
});

export const ActionsBox = styled(Box)({
  borderTop: "1px solid #492A1824",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: 16,
  width: "100%",
});
